import React, { Component, useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Button, Grid, GridColumn, GridRow, Header, Segment, Confirm, Image } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { renderToString } from "react-dom/server";
import { openModal } from "../../../app/common/modals/modalReducer";
import QuotePDFPackage from "../QuotePDF/QuotePDFPackage";
import { deleteQuote, createRevision, updateQuote, getPackageFlights, deleteHeaderImage, getQuoteTemplates } from "../quoteActions";
import format from "date-fns/format";
import { toast } from "react-toastify";
import { Formik } from "formik";
import MySelectInput from "../../../app/common/form/MySelectInput";
import MyCheckboxInput from "../../../app/common/form/MyCheckboxInput";
import addSeconds from "date-fns/addSeconds";
import subMonths from "date-fns/subMonths";
import { ErrorBoundary } from "@sentry/react";
import { openPdfWindow } from "../../../app/common/util/pdfWindow";

import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();
const LOG_URL = "https://mytiny.inspireonline.co.za/api/v1/log.php";
const QUOTE_TEMPLATES_INDEX_CACHE_PREFIX = "quote_templates_index_cache_v1:";
const QUOTE_TEMPLATES_CACHE_TTL_MS = 10 * 60 * 1000;
const MIN_INDEX_COUNT_FOR_ALL = 10;

export default function QuoteDetailedStatus(props) {
    const [opentThis, setOpentThis] = useState(false);
    let dispatch = useDispatch();
    // let quote = props.quote;
    let quotePackages = props.quotePackages;
    // let quote_templates = props.quote_templates;
    let lead = props.lead;
    let consultant = props.consultant;
    let profile = props.profile;
    let client = props.client;

    let quote = props.quote;
    let quotedate = "";

    if (quote && quote.createDate && quote.createDate !== "") {
        try {
            quotedate = format(addSeconds(new Date(0), quote.createDate.seconds), "yyyyMMdd");
        } catch (error) {
            // console.log(error.message);
        }
    }

    async function sendPerfLog(payload) {
        try {
            await fetch(LOG_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-TEST-KEY": "temp123"
                },
                body: JSON.stringify(payload),
            });
        } catch (error) {
            console.log("[perf] log failed", error?.message || error);
        }
    }

    var parts = window.location.href.split("/");
    var lastSegment = parts.pop() || parts.pop();
    const [printing, setPrinting] = useState(false);
    const [revising, setRevising] = useState(false);
    const [quote_templates, setQuote_templates] = useState([]);
    const [quoteTemplatesRaw, setQuoteTemplatesRaw] = useState([]);
    const HISTORY_STORAGE_KEY = "quote_templates_history_months_v1";
    const [templateHistoryMonths, setTemplateHistoryMonths] = useState(12);
    const [loadedTemplateHistoryMonths, setLoadedTemplateHistoryMonths] = useState(null);

    const historyMonthOptions = [
        { key: 6, text: "Last 6 months", value: 6 },
        { key: 12, text: "Last 12 months", value: 12 },
        { key: 18, text: "Last 18 months", value: 18 },
        { key: 24, text: "Last 24 months", value: 24 },
        { key: "All", text: "All time", value: "All" },
    ];

    const getNetworkInfo = () => {
        if (typeof navigator === "undefined") return {};
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return {};
        return {
            effectiveType: connection.effectiveType,
            downlink: connection.downlink,
            rtt: connection.rtt,
            saveData: connection.saveData,
        };
    };

    const resolveDate = (value) => {
        if (!value) return null;
        if (value.toDate) return value.toDate();
        if (value.seconds) return new Date(value.seconds * 1000);
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return null;
        return parsed;
    };

    const resolveTemplateDate = (template) => {
        if (!template) return null;
        return (
            resolveDate(template.createDate) ||
            resolveDate(template.createdAt) ||
            resolveDate(template.updatedAt) ||
            null
        );
    };

    const coversHistory = (loaded, requested) => {
        if (!loaded) return false;
        if (loaded === "All") return true;
        if (requested === "All") return false;
        const loadedValue = parseInt(loaded, 10);
        const requestedValue = parseInt(requested, 10);
        if (Number.isNaN(loadedValue) || Number.isNaN(requestedValue)) return false;
        return loadedValue >= requestedValue;
    };

    const applyQuoteTemplates = useCallback(
        (templateList, options = {}) => {
            const processStartMs = Date.now();
            const historyStart = templateHistoryMonths === "All" ? null : subMonths(new Date(), parseInt(templateHistoryMonths, 10));
            let missingCreatedAt = 0;
            const selectedTemplateId = quote?.template_id;

            const filtered = templateList.filter((tpl) => {
                if (selectedTemplateId && tpl.id === selectedTemplateId) return true;
                const createdAt = resolveTemplateDate(tpl);
                if (!createdAt) {
                    missingCreatedAt += 1;
                    return true;
                }
                if (!historyStart) return true;
                return createdAt >= historyStart;
            });

            let quoteTemplateList = [
                {
                    key: "",
                    text: "Choose a Header Template",
                    value: "",
                },
                {
                    key: "Custom Upload",
                    text: "Custom Upload",
                    value: "Custom Upload",
                },
            ];

            filtered.forEach((tpl) => {
                quoteTemplateList.push({
                    key: tpl.id,
                    text: tpl.template_name_admin ? tpl.template_name_admin : tpl.template_name,
                    value: tpl.id,
                });
            });

            setQuote_templates(quoteTemplateList);

            let payloadBytes = 0;
            try {
                payloadBytes = JSON.stringify(filtered).length;
            } catch (error) {
                payloadBytes = 0;
            }

            const processMs = Date.now() - processStartMs;
            const fetchMs = options.fetchMs || 0;
            const totalMs = fetchMs + processMs;

            sendPerfLog({
                action: "quote_template_list",
                durationMs: totalMs,
                fetchMs,
                processMs,
                cacheHit: options.cacheHit || false,
                source: options.source || "",
                cacheKey: options.cacheKey || "",
                indexCount: options.indexCount ?? null,
                legacyCount: options.legacyCount ?? null,
                historyMonths: templateHistoryMonths,
                count: filtered.length,
                rawCount: templateList.length,
                missingCreatedAt,
                payloadBytes,
                userId: profile?.id || "",
                displayName: profile?.displayName || "",
                email: profile?.email || "",
                network: getNetworkInfo(),
                ts: new Date().toISOString(),
            });
        },
        [templateHistoryMonths, quote?.template_id, profile]
    );

    useEffect(() => {
        try {
            const stored = sessionStorage.getItem(HISTORY_STORAGE_KEY);
            if (stored) {
                setTemplateHistoryMonths(stored === "All" ? "All" : parseInt(stored, 10));
            }
        } catch (error) {
            // ignore storage errors
        }
    }, []);

    useEffect(() => {
        try {
            sessionStorage.setItem(HISTORY_STORAGE_KEY, String(templateHistoryMonths));
        } catch (error) {
            // ignore storage errors
        }
    }, [templateHistoryMonths]);

    useEffect(() => {
        const keepKey = `${QUOTE_TEMPLATES_INDEX_CACHE_PREFIX}${templateHistoryMonths}`;
        try {
            for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
                const key = sessionStorage.key(i);
                if (!key) continue;
                if (key.startsWith(QUOTE_TEMPLATES_INDEX_CACHE_PREFIX) && key !== keepKey) {
                    sessionStorage.removeItem(key);
                }
            }
        } catch (error) {
            // ignore storage errors
        }
    }, [templateHistoryMonths]);

    useEffect(() => {
        const cacheKey = `${QUOTE_TEMPLATES_INDEX_CACHE_PREFIX}${templateHistoryMonths}`;

        if (quoteTemplatesRaw.length >= MIN_INDEX_COUNT_FOR_ALL && coversHistory(loadedTemplateHistoryMonths, templateHistoryMonths)) {
            applyQuoteTemplates(quoteTemplatesRaw, { cacheHit: true, source: "memory_superset", cacheKey });
            return;
        }
        let cached = null;
        try {
            cached = JSON.parse(sessionStorage.getItem(cacheKey));
        } catch (error) {
            cached = null;
        }

        if (
            cached &&
            Array.isArray(cached.data) &&
            cached.data.length >= MIN_INDEX_COUNT_FOR_ALL &&
            Date.now() - cached.ts < QUOTE_TEMPLATES_CACHE_TTL_MS
        ) {
            setQuoteTemplatesRaw(cached.data);
            setLoadedTemplateHistoryMonths(templateHistoryMonths);
            applyQuoteTemplates(cached.data, { cacheHit: true, source: "cache" });
            return;
        }

        const fetchIndex = () => {
            const snapStartMs = Date.now();
            let query = firestore.collection("quote_templates_index");
            const historyStart = templateHistoryMonths === "All" ? null : subMonths(new Date(), parseInt(templateHistoryMonths, 10));
            if (historyStart) {
                query = query.where("createdAt", ">=", historyStart).orderBy("createdAt", "asc");
            }
            return query.get().then((snapshot) => {
                let list = [];
                snapshot.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        list.push(appObj);
                    }
                });
                    return { list, fetchMs: Date.now() - snapStartMs, source: "index", indexCount: list.length };
                });
        };

        const fetchLegacy = () => {
            const snapStartMs = Date.now();
            return firestore
                .collection("quote_templates")
                .get()
                .then((snapshot) => {
                    let list = [];
                    snapshot.forEach((doc) => {
                        if (doc.exists) {
                            const data = doc.data();
                            let appObj = {
                                id: doc.id,
                                template_name: data.template_name,
                                template_name_admin: data.template_name_admin,
                                createDate: data.createDate,
                                createdAt: data.createdAt,
                                updatedAt: data.updatedAt,
                            };
                            list.push(appObj);
                        }
                    });
                    return { list, fetchMs: Date.now() - snapStartMs, source: "legacy", legacyCount: list.length };
                });
        };

        fetchIndex()
            .then((res) => {
                if (!res.list || res.list.length === 0) {
                    return fetchLegacy().then((legacyRes) => ({ ...legacyRes, source: "legacy_fallback", indexCount: 0 }));
                }
                if (res.list.length < MIN_INDEX_COUNT_FOR_ALL) {
                    return fetchLegacy().then((legacyRes) => ({
                        ...legacyRes,
                        source: "legacy_low_count_fallback",
                        indexCount: res.list.length,
                        legacyCount: legacyRes.list ? legacyRes.list.length : legacyRes.legacyCount,
                    }));
                }
                return res;
            })
            .then((res) => {
                if (!res || !res.list) return;
                setQuoteTemplatesRaw(res.list);
                setLoadedTemplateHistoryMonths(templateHistoryMonths);
                try {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: res.list }));
                } catch (error) {
                    // ignore cache errors
                }
                applyQuoteTemplates(res.list, {
                    fetchMs: res.fetchMs,
                    cacheHit: false,
                    source: res.source,
                    cacheKey,
                    indexCount: res.indexCount ?? null,
                    legacyCount: res.legacyCount ?? null,
                });
            })
            .catch(() => {
                fetchLegacy().then((res) => {
                    if (!res || !res.list) return;
                    setQuoteTemplatesRaw(res.list);
                    setLoadedTemplateHistoryMonths(templateHistoryMonths);
                    try {
                        sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), data: res.list }));
                    } catch (error) {
                        // ignore cache errors
                    }
                    applyQuoteTemplates(res.list, {
                        fetchMs: res.fetchMs,
                        cacheHit: false,
                        source: "legacy_error_fallback",
                        cacheKey,
                        legacyCount: res.legacyCount ?? null,
                    });
                });
            });
    }, [applyQuoteTemplates, quoteTemplatesRaw, loadedTemplateHistoryMonths, templateHistoryMonths]);

    useEffect(() => {
        if (!quoteTemplatesRaw || quoteTemplatesRaw.length === 0) return;
        applyQuoteTemplates(quoteTemplatesRaw, { cacheHit: true, source: "cache" });
    }, [templateHistoryMonths, quoteTemplatesRaw, applyQuoteTemplates]);

    const logo_division = [
        { key: "", text: "Choose a Logo", value: "" },
        { key: "Leisure", text: "Leisure", value: "Leisure" },
        { key: "Non-Leisure", text: "Non-Leisure", value: "Non-Leisure" },
    ];

    async function createRevisionFunc() {
        setRevising(true);
        quote.id = lastSegment;
        let quote_id = await createRevision(quote);
        setRevising(false);
        window.location.replace("/quotes/edit/" + quote_id);
    }

    async function deleteHeaderImageData() {
        await deleteHeaderImage(quote);
    }

    async function convertHtmlToPdf() {
        const pdfStartMs = Date.now();
        let quoteNew = quote;
        //Open the tab before any awaits so the browser does not popup-block it
        const pdfTab = openPdfWindow();
        setPrinting(true);

        await getQuoteTemplates().then(
            (res) => {
                let list = [];
                res.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), ["id"]: `${doc.id}` };
                        list.push(appObj);
                    }
                });

                quoteNew = { ...quoteNew };

                //Find Quote template
                Object.keys(list).forEach(function (key) {
                    if (list[key].id === quote.template_id) {
                        quoteNew.templateUrl = list[key].fileUrl;
                        quoteNew.template_name = list[key].template_name;
                        quoteNew.visa = list[key].visa;
                        quoteNew.destination_link = list[key].destination_link;
                        quoteNew.wording = list[key].wording ? list[key].wording : "";
                    }
                });

                //Condensed PDF?
                if (!quoteNew.condensed_pdf) {
                    quoteNew.condensed_pdf = false;
                }
            },
            (err) => {
                console.log(err);
            }
        );

        let flights = await getPackageFlights(lastSegment);

        if (flights.length > 0) {
            flights.sort((a, b) => (a.departDateTime > b.departDateTime ? 1 : -1));
        }

        const pdfPackage = renderToString(
            <ErrorBoundary>
                <QuotePDFPackage quote={quoteNew} quotePackages={quotePackages} lead={lead} profile={profile} consultant={consultant} flights={flights} />
            </ErrorBoundary>
        );

        let html = pdfPackage;

        const apiStartMs = Date.now();
        await fetch("https://v2018.api2pdf.com//chrome/html", {
            method: "post",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "104a3c14-8782-4ee5-885f-000b5a7fb8a1",
            },
            body: JSON.stringify({
                html: html,
                inlinePdf: true,
                fileName: "test.pdf",
                options: {
                    marginBottom: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0,
                },
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                const apiDurationMs = Date.now() - apiStartMs;
                if (res.success === true) {
                    pdfTab.show(res.pdf);
                } else {
                    console.log(res);
                    pdfTab.close();
                    toast.error("Something went wrong");
                }
                sendPerfLog({
                    action: "quote_pdf_generate",
                    durationMs: Date.now() - pdfStartMs,
                    apiDurationMs,
                    quoteId: quote?.id || "",
                    leadId: quote?.leadId || "",
                    userId: profile?.id || "",
                    displayName: profile?.displayName || "",
                    email: profile?.email || "",
                    ts: new Date().toISOString(),
                });
            })
            .catch((error) => {
                console.log(error);
                pdfTab.close();
                toast.error("Something went wrong");
            });
        setPrinting(false);
    }

    function openConfirm() {
        setOpentThis(true);
    }
    function closeConfirm() {
        setOpentThis(false);
    }

    async function deleteQuoteHere() {
        await deleteQuote(lastSegment);
        window.location.replace("/leads/edit/" + props.quote.leadId);
    }

    return (
        <div style={{ marginBottom: 20 }}>
            <Segment attached="top">
                <Header as="h3">Client Details - {quotedate ? quotedate + "-" + quote.quote_nr + "-" + quote.quote_rev : ""}</Header>
            </Segment>

            <Segment attached>
                <Formik
                    enableReinitialize="true"
                    initialValues={quote}
                    validate={(values) => {
                        const error = {};
                        return error;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        const saveStartMs = Date.now();
                        let quote = props.quote;

                        if (!values.logo_division || (values.logo_division !== "Leisure" && values.logo_division !== "Non-Leisure")) {
                            values.logo_division = "Leisure";
                        }
                        console.log("[perf] /quotes/edit save clicked", { quoteId: quote?.id });
                        await updateQuote(values, quote);
                        const durationMs = Date.now() - saveStartMs;
                        console.log("[perf] /quotes/edit save total ms", durationMs);
                        sendPerfLog({
                            action: "quote_save",
                            durationMs,
                            quoteId: quote?.id || "",
                            leadId: quote?.leadId || "",
                            userId: profile?.id || "",
                            displayName: profile?.displayName || "",
                            email: profile?.email || "",
                            ts: new Date().toISOString(),
                        });
                        setSubmitting(false);
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <>
                            <form onSubmit={handleSubmit} className="ui form">
                                <Grid verticalAlign="middle">
                                    <GridRow>
                                        <GridColumn width={5}>
                                            <label>Full Name</label>
                                        </GridColumn>
                                        <GridColumn width={11}>{quote.client_name}</GridColumn>
                                    </GridRow>
                                    {quote.client_email && (
                                        <GridRow>
                                            <GridColumn width={5}>
                                                <label>Email</label>
                                            </GridColumn>

                                            <GridColumn width={11}>{quote.client_email}</GridColumn>
                                        </GridRow>
                                    )}
                                    {quote.client_email && (
                                        <GridRow>
                                            <GridColumn width={5}>
                                                <label>Cell No</label>
                                            </GridColumn>
                                            <GridColumn width={11}>{quote.client_phone}</GridColumn>
                                        </GridRow>
                                    )}
                                </Grid>

                                <MySelectInput label="Logo Division" name="logo_division" options={logo_division} placeholder="Logo Division" />
                                <MySelectInput
                                    label="Header Template History"
                                    name="templateHistoryMonths"
                                    options={historyMonthOptions}
                                    value={templateHistoryMonths}
                                    placeholder="Last 12 months"
                                    onChange={(field, value) => setTemplateHistoryMonths(value.value)}
                                />
                                <MySelectInput label="Header Template" name="template_id" options={quote_templates} placeholder="Header Template" />

                                <MyCheckboxInput type="checkbox" label="" labelcb="Condensed PDF" name="condensed_pdf" />

                                {quote && quote.template_id && quote.template_id === "Custom Upload" && (
                                    <div style={{ marginTop: 10 }}>
                                        {quote.fileUrl && quote.fileUrl.length > 0 ? (
                                            <Grid verticalAlign="middle">
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <label>
                                                            <strong>Custom Header Image</strong>
                                                        </label>
                                                    </Grid.Column>

                                                    <Grid.Column width={11}>
                                                        {/* <Form.Field> */}
                                                        <Image size="small" style={{ marginTop: 20 }} src={quote.fileUrl} />

                                                        <Button size="medium" color="orange" content="Delete" onClick={deleteHeaderImageData} />
                                                        {/* </Form.Field> */}
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        ) : (
                                            <Grid verticalAlign="middle">
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <label>
                                                            <strong>Upload Header Image</strong>
                                                        </label>
                                                    </Grid.Column>

                                                    <Grid.Column width={11}>
                                                        <input
                                                            id="uploadFile"
                                                            name="uploadFile"
                                                            type="file"
                                                            onChange={(event) => {
                                                                setFieldValue("uploadFile", event.currentTarget.files[0]);
                                                            }}
                                                            className="form-control"
                                                        />
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        )}
                                    </div>
                                )}
                                <Grid verticalAlign="middle">
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Button disabled={isSubmitting} loading={isSubmitting} size="medium" color="orange" content="Save" />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </form>
                        </>
                    )}
                </Formik>
            </Segment>

            <Segment attached="bottom" className="buttons_row">
                <Button size="medium" color="orange" content="Create Revision" loading={revising} onClick={createRevisionFunc} />

                <Button size="medium" color="orange" content="Back to Lead" as={Link} to={"/leads/edit/" + quote.leadId} />

                {quotePackages && quotePackages.length > 0 && <Button size="medium" color="orange" content="Print PDF" loading={printing} onClick={convertHtmlToPdf} />}
                {quotePackages && quotePackages.length > 0 && (
                    <Button
                        size="medium"
                        disabled={!quote || !quote.client_email || quote.client_email.length === 0}
                        color="orange"
                        onClick={() => {
                            sendPerfLog({
                                action: "quote_email_open",
                                quoteId: quote?.id || "",
                                leadId: quote?.leadId || "",
                                userId: profile?.id || "",
                                displayName: profile?.displayName || "",
                                email: profile?.email || "",
                                ts: new Date().toISOString(),
                            });
                            dispatch(
                                openModal({
                                    modalType: "LeadGeneralEmailModal",
                                    modalProps: {
                                        leadId: quote.leadId,
                                        quoteId: lastSegment,
                                        client_email: quote.client_email,
                                        initialValues: {
                                            subject: "",
                                            to: quote.client_email,
                                            bcc: profile.email,
                                            message: profile.fileUrl && profile.fileUrl !== "" ? profile.defaultQuoteMessage + "<img src='" + profile.fileUrl + "' />" : profile.defaultQuoteMessage,
                                            cc: client.client_cc_email,
                                        },
                                        emailType: "Email Quote",
                                        profile,
                                        includeQuote: true,
                                        quote,
                                        quotePackages,
                                        quote_templates,
                                        lead,
                                        consultant,
                                    },
                                })
                            );
                        }}
                        content="Email Client"
                    />
                )}
                <Button size="medium" color="red" content="Delete" onClick={openConfirm} />
            </Segment>

            <Confirm
                header="You are about to delete this quote"
                content="This cannot be undone, are you sure?"
                size="tiny"
                open={opentThis}
                onCancel={closeConfirm}
                onConfirm={deleteQuoteHere}
                confirmButton="Yes"
            />
        </div>
    );
}
